import {
  ClientShippingLabelSettings,
  DomainBranding,
  DomainTree,
} from '@rygen/rygen-ui/model';

import { CreditUsage, LoadboardSource } from '@/model';
import { DefaultOrderData } from '@/model/DefaultOrderData';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'client';

export class ClientController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getAvailableDomains(): Promise<DomainTree[]> {
    const response = await this.http.get<DomainTree[]>('');
    return response.data.map((val) => new DomainTree(val));
  }

  async getCurrentClientBranding(): Promise<DomainBranding> {
    const response = await this.http.get<DomainBranding>(`current/branding`);
    return new DomainBranding(response.data);
  }

  async isMacroPointEnabled(): Promise<boolean> {
    const response = await this.http.get<boolean>('macropoint-enabled');
    return response.data;
  }

  async isCarrierConnectEnabled(): Promise<boolean> {
    const response = await this.http.get<boolean>('carrier-connect-enabled');
    return response.data;
  }

  async getConfiguredLoadboards(): Promise<LoadboardSource[]> {
    const response = await this.http.get<LoadboardSource[]>(
      'loadboard-integrations',
    );
    return response.data;
  }

  async getDefaultOrderData(): Promise<DefaultOrderData> {
    const response =
      await this.http.get<DefaultOrderData>(`default-order-data`);
    return new DefaultOrderData(response.data);
  }

  async getAllSummaries(): Promise<DomainTree[]> {
    const resposne = await this.http.get<DomainTree[]>('summaries');
    return resposne.data.map((val) => new DomainTree(val));
  }

  async getCreditUsage(): Promise<CreditUsage> {
    const response = await this.http.get<CreditUsage>('credit-limit');
    return new CreditUsage(response.data);
  }

  async getClientShippingLabelSettings(): Promise<ClientShippingLabelSettings> {
    const response = await this.http.get<ClientShippingLabelSettings>(
      'shipping-label-settings',
    );
    return new ClientShippingLabelSettings(response.data);
  }
}
